<template>
    <div class="flex flex-col min-w-0 flex-1 overflow-hidden h-full">
        <div class="flex-1 relative z-0 flex overflow-hidden">
            <section
                v-if="conversation !== undefined && conversation !== null"
                aria-labelledby="message-heading"
                class="min-w-0 flex-1 h-full flex flex-col overflow-hidden xl:order-last"
            >
                <nav class="flex xl:hidden items-start px-4 py-3 sm:px-6 lg:px-8 xl:hidden" aria-label="Breadcrumb">
                    <button
                        @click="directoryOpen = true"
                        class="inline-flex items-center space-x-3 text-sm font-medium text-gray-900"
                    >
                        <svg
                            class="-ml-2 h-5 w-5 text-gray-400"
                            x-description="Heroicon name: solid/chevron-left"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                        <span>{{ $tc('messages.conversations', 2) }}</span>
                    </button>
                </nav>
                <!-- Top section -->
                <div class="shrink-0 bg-white border-b border-gray-200">
                    <!-- Toolbar-->
                    <div class="h-16 flex flex-col justify-center">
                        <div class="px-4 sm:px-6 lg:px-8">
                            <div class="py-3 flex justify-between">
                                <!-- Left buttons -->
                                <div class="relative z-0 flex space-x-2" v-if="conversation.id">
                                    <form
                                        @submit.prevent="archiveConversation(conversation.id)"
                                        v-if="!conversation.is_archived"
                                    >
                                        <AppButton element="button" type="submit">
                                            <svg
                                                class="mr-2.5 h-5 w-5 text-gray-400"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                            {{ $t('messages.archive') }}
                                        </AppButton>
                                    </form>

                                    <form
                                        @submit.prevent="
                                            $inertia.delete(route('conversations.archive.delete', conversation.id))
                                        "
                                        v-else
                                    >
                                        <AppButton element="button" type="submit">
                                            <svg
                                                class="mr-2.5 h-5 w-5 text-gray-400"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                            {{ $t('messages.unarchive') }}
                                        </AppButton>
                                    </form>

                                    <form
                                        @submit.prevent="
                                            $inertia.post(route('conversations.pin.store', conversation.id))
                                        "
                                        v-if="!conversation.is_pinned"
                                    >
                                        <AppButton element="button" type="submit">
                                            <svg
                                                class="mr-2.5 h-5 w-5 text-gray-400"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                                                ></path>
                                            </svg>
                                            {{ $t('messages.pin_to_top') }}
                                        </AppButton>
                                    </form>

                                    <form
                                        @submit.prevent="
                                            $inertia.delete(route('conversations.pin.delete', conversation.id))
                                        "
                                        v-else
                                    >
                                        <AppButton element="button" type="submit">
                                            <svg
                                                class="mr-2.5 h-5 w-5 text-gray-400"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
                                                ></path>
                                            </svg>
                                            {{ $t('messages.unpin_from_top') }}
                                        </AppButton>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Message header -->
                </div>

                <div class="bg-white pt-5 pb-6 shadow">
                    <div class="px-4 flex sm:justify-between items-center sm:px-6 lg:px-8">
                        <div class="shrink-0">
                            <img class="h-10 w-10 rounded-full mr-3" :src="conversation.other_user.avatar_or_default" />
                        </div>
                        <div class="sm:w-0 sm:flex-1">
                            <h1 id="message-heading" class="lg:text-lg font-medium text-gray-900">
                                {{ conversation.other_user.full_name }}
                                <span v-if="conversation.other_user.group_name" class="font-light text-sm">
                                    ({{ $t('messages.tutor_of_group', { group: conversation.other_user.group_name }) }})
                                </span>
                            </h1>
                            <p class="mt-1 text-sm text-gray-500 truncate" style="display: none">
                                joearmstrong@example.com
                            </p>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-200 shadow" v-if="user.type === 'teacher'">
                    <form
                        @submit.prevent="
                            form.post(route('conversations.store'));
                            form.message = null;
                        "
                    >
                        <div
                            class="relative flex items-center self-center w-full p-4 overflow-hidden text-gray-600 focus-within:text-gray-400"
                        >
                            <div class="w-full">
                                <span class="absolute inset-y-0 left-0 flex items-center pl-6" style="display: none">
                                    <button type="submit" class="p-1 focus:outline-none focus:shadow-none">
                                        <svg
                                            class="w-6 h-6 fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                fill-rule="nonzero"
                                                d="M9.5,3 C13.0898509,3 16,5.91014913 16,9.5 C16,10.9337106 15.5358211,12.2590065 14.7495478,13.3338028 L19.7071068,18.2928932 C20.0976311,18.6834175 20.0976311,19.3165825 19.7071068,19.7071068 C19.3466228,20.0675907 18.7793918,20.0953203 18.3871006,19.7902954 L18.2928932,19.7071068 L13.3338028,14.7495478 C12.2590065,15.5358211 10.9337106,16 9.5,16 C5.91014913,16 3,13.0898509 3,9.5 C3,5.91014913 5.91014913,3 9.5,3 Z M9.5,5 C7.01471863,5 5,7.01471863 5,9.5 C5,11.9852814 7.01471863,14 9.5,14 C11.9852814,14 14,11.9852814 14,9.5 C14,7.01471863 11.9852814,5 9.5,5 Z"
                                            ></path>
                                        </svg>
                                    </button>
                                </span>
                                <span class="absolute inset-y-0 right-0 flex items-center pr-6">
                                    <button
                                        type="submit"
                                        class="p-1 focus:outline-none focus:shadow-none hover:text-blue-500"
                                    >
                                        <svg
                                            class="w-6 h-6 fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                fill-rule="nonzero"
                                                d="M6.43800037,12.0002892 L6.13580063,11.9537056 C5.24777712,11.8168182 4.5354688,11.1477159 4.34335422,10.2699825 L2.98281085,4.05392998 C2.89811796,3.66698496 2.94471512,3.2628533 3.11524595,2.90533607 C3.53909521,2.01673772 4.60304421,1.63998415 5.49164255,2.06383341 L22.9496381,10.3910586 C23.3182476,10.5668802 23.6153089,10.8639388 23.7911339,11.2325467 C24.2149912,12.1211412 23.8382472,13.1850936 22.9496527,13.6089509 L5.49168111,21.9363579 C5.13415437,22.1068972 4.73000953,22.1534955 4.34305349,22.0687957 C3.38131558,21.8582835 2.77232686,20.907987 2.9828391,19.946249 L4.34336621,13.7305987 C4.53547362,12.8529444 5.24768451,12.1838819 6.1356181,12.0469283 L6.43800037,12.0002892 Z M5.03153725,4.06023585 L6.29710294,9.84235424 C6.31247211,9.91257291 6.36945677,9.96610109 6.44049865,9.97705209 L11.8982869,10.8183616 C12.5509191,10.9189638 12.9984278,11.5295809 12.8978255,12.182213 C12.818361,12.6977198 12.4138909,13.1022256 11.8983911,13.1817356 L6.44049037,14.0235549 C6.36945568,14.0345112 6.31247881,14.0880362 6.29711022,14.1582485 L5.03153725,19.9399547 L21.6772443,12.0000105 L5.03153725,4.06023585 Z"
                                            ></path>
                                        </svg>
                                    </button>
                                </span>
                                <input
                                    type="text"
                                    name="message"
                                    v-model="form.message"
                                    required
                                    minlength="1"
                                    class="w-full py-2 pl-10 text-sm bg-white border border-transparent appearance-none rounded-tg placeholder-gray-800 focus:bg-white focus:outline-none focus:border-blue-500 focus:text-gray-900 focus:shadow-outline-blue"
                                    style="border-radius: 25px"
                                    :placeholder="$t('messages.message') + ` ...`"
                                    autocomplete="off"
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div class="min-h-0 flex-1 overflow-y-auto">
                    <div class="bg-white pt-5 pb-6 shadow" style="display: none">
                        <div class="px-4 sm:flex sm:justify-between sm:items-baseline sm:px-6 lg:px-8">
                            <div class="sm:w-0 sm:flex-1">
                                <h1 id="message-heading" class="text-lg font-medium text-gray-900">
                                    Re: New pricing for existing customers
                                </h1>
                                <p class="mt-1 text-sm text-gray-500 truncate">joearmstrong@example.com</p>
                            </div>

                            <div
                                class="mt-4 flex items-center justify-between sm:mt-0 sm:ml-6 sm:shrink-0 sm:justify-start"
                            >
                                <span
                                    class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-cyan-100 text-cyan-800"
                                >
                                    Open
                                </span>
                                <div class="ml-3 relative inline-block text-left">
                                    <div>
                                        <button
                                            type="button"
                                            class="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                            id="menu-3-button"
                                            aria-expanded="false"
                                            aria-haspopup="true"
                                        >
                                            <span class="sr-only">Open options</span>
                                            <!-- Heroicon name: solid/dots-vertical -->
                                            <svg
                                                class="h-5 w-5"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                                                />
                                            </svg>
                                        </button>
                                    </div>

                                    <!--
                                      Dropdown menu, show/hide based on menu state.

                                      Entering: "transition ease-out duration-100"
                                        From: "transform opacity-0 scale-95"
                                        To: "transform opacity-100 scale-100"
                                      Leaving: "transition ease-in duration-75"
                                        From: "transform opacity-100 scale-100"
                                        To: "transform opacity-0 scale-95"
                                    -->
                                    <div
                                        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                        role="menu"
                                        aria-orientation="vertical"
                                        aria-labelledby="menu-3-button"
                                        tabindex="-1"
                                    >
                                        <div class="py-1" role="none">
                                            <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
                                            <button
                                                type="button"
                                                class="text-gray-700 w-full flex justify-between px-4 py-2 text-sm"
                                                role="menuitem"
                                                tabindex="-1"
                                                id="menu-3-item-0"
                                            >
                                                <span>Copy email address</span>
                                            </button>
                                            <a
                                                href="#"
                                                class="text-gray-700 flex justify-between px-4 py-2 text-sm"
                                                role="menuitem"
                                                tabindex="-1"
                                                id="menu-3-item-1"
                                            >
                                                <span>Previous conversations</span>
                                            </a>
                                            <a
                                                href="#"
                                                class="text-gray-700 flex justify-between px-4 py-2 text-sm"
                                                role="menuitem"
                                                tabindex="-1"
                                                id="menu-3-item-2"
                                            >
                                                <span>View original</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Thread section-->
                    <div v-if="conversation.messages.length === 0" class="flex justify-center">
                        <svg
                            width="600"
                            height="337"
                            viewBox="0 0 800 600"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                opacity="0.7"
                                d="M158.554 404.627H666.487C734.829 404.627 790 349.456 790 281.114C790 212.773 734.829 157.602 666.487 157.602H185.25C123.672 157.602 73.8394 207.434 73.8394 269.012V375.796L10 442.402L158.554 404.627Z"
                                fill="#C4B6FF"
                            ></path>
                            <path
                                d="M536.428 309.184C553.531 309.184 567.395 295.32 567.395 278.217C567.395 261.114 553.531 247.25 536.428 247.25C519.325 247.25 505.461 261.114 505.461 278.217C505.461 295.32 519.325 309.184 536.428 309.184Z"
                                fill="#7D55FF"
                            ></path>
                            <path
                                d="M440.022 309.184C457.125 309.184 470.989 295.32 470.989 278.217C470.989 261.114 457.125 247.25 440.022 247.25C422.919 247.25 409.055 261.114 409.055 278.217C409.055 295.32 422.919 309.184 440.022 309.184Z"
                                fill="#B5CDFB"
                            ></path>
                            <path
                                d="M320.831 299.574C326.526 305.625 334.713 309.184 343.611 309.184C360.697 309.184 374.578 295.303 374.578 278.217C374.578 261.132 360.697 247.25 343.611 247.25C326.526 247.25 312.644 261.132 312.644 278.217C312.288 286.404 315.492 293.879 320.831 299.574Z"
                                fill="#C4B6FF"
                            ></path>
                        </svg>
                    </div>
                    <MessageList :messages="conversation.messages" :conversation="conversation" v-else />
                </div>
            </section>
            <div
                v-else
                class="min-w-0 flex-1 h-full flex flex-col justify-center items-center overflow-hidden xl:order-last"
            >
                <svg width="600" height="337" viewBox="0 0 800 600" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        opacity="0.7"
                        d="M158.554 404.627H666.487C734.829 404.627 790 349.456 790 281.114C790 212.773 734.829 157.602 666.487 157.602H185.25C123.672 157.602 73.8394 207.434 73.8394 269.012V375.796L10 442.402L158.554 404.627Z"
                        fill="#C4B6FF"
                    ></path>
                    <path
                        d="M536.428 309.184C553.531 309.184 567.395 295.32 567.395 278.217C567.395 261.114 553.531 247.25 536.428 247.25C519.325 247.25 505.461 261.114 505.461 278.217C505.461 295.32 519.325 309.184 536.428 309.184Z"
                        fill="#7D55FF"
                    ></path>
                    <path
                        d="M440.022 309.184C457.125 309.184 470.989 295.32 470.989 278.217C470.989 261.114 457.125 247.25 440.022 247.25C422.919 247.25 409.055 261.114 409.055 278.217C409.055 295.32 422.919 309.184 440.022 309.184Z"
                        fill="#B5CDFB"
                    ></path>
                    <path
                        d="M320.831 299.574C326.526 305.625 334.713 309.184 343.611 309.184C360.697 309.184 374.578 295.303 374.578 278.217C374.578 261.132 360.697 247.25 343.611 247.25C326.526 247.25 312.644 261.132 312.644 278.217C312.288 286.404 315.492 293.879 320.831 299.574Z"
                        fill="#C4B6FF"
                    ></path>
                </svg>
            </div>
            <aside
                :class="directoryOpen ? 'flex' : ' hidden xl:flex '"
                class="xl:order-first flex-col shrink-0 w-96 border-r border-gray-200"
            >
                <div class="px-6 pt-6 pb-4">
                    <h2 class="text-lg font-medium text-gray-900" style="display: none">Directory</h2>
                    <p class="mt-1 text-sm text-gray-600" style="display: none">Search directory of 3,018 employees</p>
                    <AppButton
                        element="InertiaLink"
                        :href="route('conversations.batch.create')"
                        v-if="$page.props.auth.user.type === 'teacher'"
                    >
                        <svg
                            class="w-4 h-4 text-gray-500 mr-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                            ></path>
                        </svg>
                        {{ $t('messages.group_message') }}
                    </AppButton>
                    <ConversationsPaginator :paginator="conversations"></ConversationsPaginator>
                    <form class="mt-6 flex space-x-4" @submit.prevent="filter">
                        <div class="flex-1 min-w-0">
                            <label for="search" class="sr-only">{{ $t('messages.search') }}</label>
                            <div class="relative rounded-md shadow-sm">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <!-- Heroicon name: mail -->
                                    <!-- Heroicon name: search -->
                                    <svg
                                        class="h-5 w-5 text-gray-400"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    name="search"
                                    id="search"
                                    v-model="filterForm.search"
                                    class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                    :placeholder="$t('messages.search')"
                                />
                            </div>
                        </div>
                        <button
                            type="button"
                            class="inline-flex justify-center px-3.5 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <!-- Heroicon name: filter -->
                            <svg
                                class="h-5 w-5 text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                @click="showFilters = !showFilters"
                                aria-hidden="true"
                            >
                                <path
                                    d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                                ></path>
                            </svg>
                            <span class="sr-only">{{ $t('messages.search') }}</span>
                        </button>
                    </form>

                    <div v-show="showFilters" class="bg-gray-200 overflow-hidden rounded-lg mt-3">
                        <div class="px-4 py-5 sm:p-6">
                            <!-- Content goes here -->
                            <AppButton
                                element="button"
                                type="button"
                                @click="
                                    filterForm.status = 'archived';
                                    filter();
                                "
                                v-if="filterForm.status !== 'archived'"
                            >
                                {{ $t('messages.show_archived') }}
                            </AppButton>
                            <AppButton
                                element="button"
                                type="button"
                                @click="
                                    filterForm.status = null;
                                    filter();
                                "
                                v-else
                            >
                                <svg
                                    class="w-4 h-4 text-gray-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                                {{ $t('messages.show_archived') }}
                            </AppButton>

                            <inertia-link
                                :href="route('conversations.archive.all.store')"
                                v-if="filterForm.status !== 'archived'"
                                method="post"
                                as="button"
                                type="button"
                                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                {{ $t('messages.archive_all') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>
                <!-- Directory list -->
                <ConversationList :conversations="conversations.data" @open-conversation-with="openConversationWith" />
            </aside>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import MessageList from '@/components/pageSpecific/messaging/MessageList.vue';
import ConversationList from '@/components/pageSpecific/messaging/ConversationList.vue';
import ConversationsPaginator from '@/components/pageSpecific/messaging/ConversationsPaginator.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    layout: Layout,
    components: {
        AppButton,
        MessageList,
        ConversationList,
        ConversationsPaginator,
    },
    name: 'Show',
    props: ['conversations', 'conversation', 'recipient', 'filters'],
    data() {
        return {
            showFilters: this.filters.status === 'archived',
            directoryOpen: !this.conversation,
            user: this.$page.props.auth.user,
            form: this.$inertia.form({
                message: null,
                recipient_id: this.conversation ? this.conversation.other_user.id : null,
            }),
            filterForm: this.$inertia.form({
                search: this.filters.search,
                status: this.filters.status,
                w: this.filters.w,
            }),
        };
    },
    methods: {
        filter() {
            this.filterForm.get(
                route('messages.show'),
                {},
                {
                    only: ['conversations'],
                },
            );
        },
        openConversationWith(userId) {
            this.filterForm.w = userId;
            this.$inertia.get(
                route('messages.show', {
                    w: userId,
                    search: this.filterForm.search,
                    status: this.filterForm.status,
                }),
            );
        },
        archiveConversation(conversation_id) {
            this.$inertia.post(route('conversations.archive.store', conversation_id), {
                redirectUrl: route('messages.show', {
                    w: null,
                    search: this.filterForm.search,
                    status: this.filterForm.status,
                }),
            });
        },
    },
};
</script>
